import "core-js/modules/web.dom-collections.iterator.js";
import T from 'prop-types';
import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { usePopper, modifiers as mod, placements } from '../../hooks/usePopper';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Anchor = /*#__PURE__*/styled.div.withConfig({
  displayName: "Anchor",
  componentId: "sc-152ub38-0"
})(["display:inline-flex;"]);

const Tether = ({
  children,
  attachment,
  placement = 'bottom-start',
  zIndex = 9999,
  modifiers
}) => {
  const referenceRef = useRef(null);
  const [popperElement, setPopperElement] = useState(null);
  const {
    styles
  } = usePopper(referenceRef, popperElement, {
    placement,
    modifiers,
    zIndex
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [typeof children === 'function' ? children({
      ref: referenceRef
    }) : /*#__PURE__*/_jsx(Anchor, {
      ref: referenceRef,
      children: children
    }), attachment && /*#__PURE__*/createPortal(typeof attachment === 'function' ? attachment({
      ref: setPopperElement,
      style: styles.popper,
      placement
    }) : /*#__PURE__*/_jsx("div", {
      ref: setPopperElement,
      style: styles.popper,
      "data-placement": placement,
      children: attachment
    }), document.body)]
  });
};

Tether.propTypes = {
  children: T.oneOfType([T.func, T.node]).isRequired,
  attachment: T.oneOfType([T.func, T.node]),
  placement: T.oneOf(placements),
  zIndex: T.oneOfType([T.number, T.string]),
  modifiers: T.arrayOf(T.shape({}))
};
export { Tether, mod as modifiers };